module.exports = __webpack_public_path__ + "img/Gallery_2_28.f6f1bbdc.jpeg";